import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainEditSyncConfigGroup(data) {
  return maintainRequest({
    url: `/device/maintenanceMan/device_group/edit_t4/${data.id}`,
    data: { t4: data.t4 },
    method: "post",
  });
}
